export default __webpack_public_path__ + "assets/margin-onboarding-3-9dd34df4182f07eb2fd8580d81d2c658.png";